import { isColorBright, resolveColorProperty } from '@gn-audio/jss-components';
import { PartnerOverview } from '@gn-audio/jss-core';

import { BADGES, EXPERTISE_MAPPING, ExpertiseBadgeColors, ExpertiseOption } from './constants';

type BadgeType = {
  label: string;
  className: string;
  backgroundColor?: string;
};

const getBadgeColor = (
  badgeType: string,
  badgeColorsMap: ExpertiseBadgeColors
): string | undefined => {
  return Object.entries(badgeColorsMap).find(([tierName]) => badgeType.includes(tierName))?.[1];
};

export const getPartnerBadge = (
  partner: PartnerOverview,
  badgeColorsMap: ExpertiseBadgeColors,
  selectedExpertise?: ExpertiseOption | null
): BadgeType | null => {
  const { gnh_audiopartnerprogram, gnh_videopartnerprogram } = partner;

  const filterType = selectedExpertise?.type;

  for (const [code, tier] of Object.entries(EXPERTISE_MAPPING)) {
    if (
      (filterType === 'video' && gnh_videopartnerprogram?.includes(code)) ||
      (filterType === 'audio' && gnh_audiopartnerprogram?.includes(code)) ||
      (!filterType &&
        (gnh_videopartnerprogram?.includes(code) || gnh_audiopartnerprogram?.includes(code)))
    ) {
      const badgeKey = tier.general;
      const badge = BADGES[badgeKey];
      const customColor = getBadgeColor(badgeKey, badgeColorsMap);
      const resolvedHex = resolveColorProperty(customColor || badge.className);

      return {
        ...badge,
        backgroundColor: resolvedHex,
        className: isColorBright(resolvedHex) ? 'text-black' : 'text-white',
      };
    }
  }

  return null;
};

type PartnerOverviewBadgeProps = {
  partner: PartnerOverview;
  badgeColorsMap: ExpertiseBadgeColors;
  selectedExpertise?: ExpertiseOption | null;
};

export const PartnerOverviewBadge = ({
  partner,
  badgeColorsMap,
  selectedExpertise,
}: PartnerOverviewBadgeProps) => {
  const badge = getPartnerBadge(partner, badgeColorsMap, selectedExpertise);

  if (!badge) return null;

  return (
    <div
      className={`inline-block rounded-l-full px-3 py-1 font-light ${badge.className}`}
      {...(badge.backgroundColor && { style: { backgroundColor: badge.backgroundColor } })}
    >
      {badge.label}
    </div>
  );
};

export default PartnerOverviewBadge;
